import { render, staticRenderFns } from "./ContractSection.vue?vue&type=template&id=16632664&scoped=true&"
import script from "./ContractSection.vue?vue&type=script&lang=js&"
export * from "./ContractSection.vue?vue&type=script&lang=js&"
import style0 from "./ContractSection.vue?vue&type=style&index=0&id=16632664&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16632664",
  null
  
)

export default component.exports